var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"container"},[_c('div',{staticClass:"boleto"},[_c('img',{attrs:{"id":"boleto","src":require("../assets/images/Boleto.jpg"),"alt":""}}),_c('b-button',{on:{"click":_vm.exportToPDF}},[_vm._v("Imprimir")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }